




































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import FileService, { FileViewModel } from '../../api/file';
import global from '../../utils/global';
import FilePreview from './Preview.vue';

@Component({
  components: {
    FilePreview,
  },
})
export default class FileList extends Vue {
  @Prop() private timelineItemId!: number;
  @Prop() private condition!: FileViewModel;
  @Prop({default: false}) private isFrame!: boolean;
  private service: FileService = new FileService();
  private data: FileViewModel[] = [];
  // private timelineItemId: number = 0;
  private imgUrl: string = `${global.BACKGROUND_URL}/resource/thumb/` ;
  private showPreview: boolean = false;
  private previewUrls: any[] = [];
  private currrentRow: any = this.service.NewModel;
  private pageIndex: number = 1;
  private pageCount: number = -1;
  private totalCount: number = 0;

  @Watch('condition')
  private condition_OnChange(val: any, oldVal: any) {
    this.Search(val);
  }
  private mounted() {
    // this.timelineItemId = parseInt(this.$route.query.id + '');
    if (this.timelineItemId > 0) {
      this.service.GetByTimeline(this.timelineItemId, 12).then((response: any) => {
        this.data = response;
      });
    } else if (this.condition !== undefined) {
      this.Search(this.condition);
    }
  }

  private loadData(pageIndex: number) {
    this.service.Search(this.condition, this.pageIndex).then((response: any) => {
      this.data = response.list;
      this.pageCount = response.pageCount;
      this.totalCount = response.totalCount;
      this.pageIndex = pageIndex;
      this.OnLoaded(response.totalCount);
    });
  }

  @Emit('OnLoaded')
  private OnLoaded(totalCount: number) {
    return totalCount;
  }

  private page_OnChange(page: number) {
    this.loadData(page);
  }

  private Search(condition: FileViewModel) {
    this.condition = condition;
    this.loadData(1);
  }

  private btnPreview_OnClick(val: any) {
    if (this.isFrame) {
      (window.parent as any).vm.preview_OnClick(val);
      return;
    }
    this.currrentRow = val;
    this.showPreview = true;
  }
}

